import * as React from "react";
import { forwardRef } from "react";
const MasterCardIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 48 48",
  "data-category": "payment-methods",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M3 8h41.8059v27.9678H3z",
  opacity: 0.01
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF5F00",
  d: "M18.3905 12.8727h11.0282V31.092H18.3905z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EB001B",
  fillRule: "evenodd",
  d: "M19.5264 21.9839c-.0028-3.5547 1.6105-6.9133 4.375-9.108-4.6965-3.73336-11.4407-3.18957-15.49314 1.2492-4.0524 4.4387-4.0524 11.2821 0 15.7209 4.05244 4.4387 10.79664 4.9825 15.49314 1.2492-2.7654-2.1955-4.3788-5.5555-4.375-9.1113",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F79E1B",
  fillRule: "evenodd",
  d: "M41.5655 28.868v.7467h-.1416v-.7467h-.3025v-.1544h.7659v.1544zm1.4869-.1544v.9011h-.1609v-.6823l-.2511.5858h-.1737l-.2511-.5858v.6823h-.1673v-.9011h.2317l.2703.6436.2704-.6436zm-.6169-6.7297c-.0001 4.436-2.5043 8.4826-6.449 10.4211s-8.6374 1.4287-12.0851-1.313c2.7632-2.1967 4.3766-5.5548 4.3766-9.1097s-1.6134-6.9131-4.3766-9.1097c3.4477-2.7417 8.1404-3.25154 12.0851-1.313 3.9447 1.9385 6.4489 5.9851 6.449 10.4211z",
  clipRule: "evenodd"
}));
const ForwardRef = forwardRef(MasterCardIcon);
ForwardRef.category = "payment-methods";
export { ForwardRef as MasterCardIcon };